import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RepeatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"repeat"}/>
}
